var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16C0 7.16345 7.16345 0 16 0C24.8366 0 32 7.16345 32 16C32 24.8366 24.8366 32 16 32C7.16345 32 0 24.8366 0 16Z",
    fill: "#9D9DA1",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3771 8.15621C16.1688 7.94793 15.8312 7.94793 15.6229 8.15621L8.15621 15.6229C7.94793 15.8312 7.94793 16.1688 8.15621 16.3771C8.36449 16.5854 8.70218 16.5854 8.91046 16.3771L15.4667 9.82091V23.4844C15.4667 23.7692 15.7054 24 16 24C16.2946 24 16.5333 23.7692 16.5333 23.4844V9.82091L23.0895 16.3771C23.2978 16.5854 23.6355 16.5854 23.8438 16.3771C24.0521 16.1688 24.0521 15.8312 23.8438 15.6229L16.3771 8.15621Z",
    fill: "#828285"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpGray);
export default __webpack_public_path__ + "static/media/arrow-up-gray.936d0a56c68b7a494a8ffd07b9e47f3a.svg";
export { ForwardRef as ReactComponent };